// Angular
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Material
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatBadgeModule } from '@angular/material/badge';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLegacyNativeDateModule as MatNativeDateModule } from '@angular/material/legacy-core';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';

// Hub Libs
import { ControlBarModule } from '@libs/components/control-bar';
import { SearchInputModule } from '@libs/components/search-input';

// Local
import { MultiFilterTypeaheadComponent } from './components/filters/multi-filter-typeahead/multi-filter-typeahead.component';
import { CheckboxListComponent } from './components/filters/checkbox-list/checkbox-list.component';
import { SearchFilterComponent } from './components/search-filter/search-filter.component';
import { FilterHeaderComponent } from './components/filter-header/filter-header.component';
import { TextInputComponent } from './components/filters/text-input/text-input.component';
import { DateRangeComponent } from './components/filters/date-range/date-range.component';
import { RadioButtonListComponent } from './components/filters/radio-button-list/radio-button-list.component';
import { DropdownTypeaheadFilterComponent } from './components/exposed-filters/dropdown-typeahead/dropdown-typeahead-filter.component';

// SAJ Material Components
import { SAJDatepickerHeaderModule } from '@snagajob/angular/components/datepicker-header';
import { SAJIconFilterComponent } from '@snagajob/icons';
@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ControlBarModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatInputModule,
    MatCheckboxModule,
    MatIconModule,
    MatFormFieldModule,
    MatBadgeModule,
    MatSidenavModule,
    MatSnackBarModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatChipsModule,
    MatListModule,
    MatMenuModule,
    MatRadioModule,
    SAJDatepickerHeaderModule,
    SearchInputModule,

    SAJIconFilterComponent,
  ],
  providers: [MatDatepickerModule],
  declarations: [
    MultiFilterTypeaheadComponent,
    CheckboxListComponent,
    SearchFilterComponent,
    TextInputComponent,
    DateRangeComponent,
    FilterHeaderComponent,
    DropdownTypeaheadFilterComponent,
    RadioButtonListComponent,
  ],
  exports: [SearchFilterComponent, DropdownTypeaheadFilterComponent],
})
export class SAJMultiFilterModule {}
